/* eslint-disable */
import vueDanmaku from 'vue-danmaku'

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css';
import bannerN from '../assets/banner.png'
import bannerS from '../assets/banner_s.png'
import { api } from "../request/api.js"
import { mapState, mapMutations, mapGetters } from 'vuex'


import Vue from 'vue'
import VueScrollTo from "vue-scrollto";
Vue.use(VueScrollTo, {
    container: "body", //滚动的容器
    duration: 500, //滚动时间
    easing: "ease", //缓动类型
    offset: 0, //滚动时应应用的偏移量。此选项接受回调函数
    force: true, //是否应执行滚动
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true,
});

// 统计上报地址，本地开发时自动指向 localhost:3100
const STATS_BASE = location.hostname === 'pre.vndragonraja.com'
    ? 'https://stat-api.vndragonraja.com'
    : 'http://localhost:3100'

function trackPv(channel) {
    try {
        fetch(`${STATS_BASE}/track/pv`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                channel: channel || '',
                referer: document.referrer || ''
            }),
            keepalive: true
        }).catch(() => {})
    } catch (e) {}
}

function trackClick(event, channel) {
    try {
        fetch(`${STATS_BASE}/track/click`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                event: event || '',
                channel: channel || ''
            }),
            keepalive: true
        }).catch(() => {})
    } catch (e) {}
}

export default {
    name: 'Home',
    components: {
        swiper,
        swiperSlide
    },
    created() {
        // console.log('------------------初始化阶段------------------')
        this.initStore()
    },
    computed: {
        ...mapState(['userInfo']),
        swiper() {
            return this.$refs.mySwiper.swiper
        },
        tipTime() {
            const total = this.tipCountdown
            const m = Math.floor(total / 60)
            const s = total % 60
            const ms = this.tipMs
            const pad = n => String(n).padStart(2, '0')
            return `${pad(m)}:${pad(s)}:${pad(ms)}`
        },
    },
    data() {
        return {
            showFloat: 1,
            people: 320000,
            isAndroid: true,
            p: parseInt(new URLSearchParams(window.location.search).get('p') || '0', 10),
            swiperOption: {
                autoplay: true,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'custom',
                    clickable: true,
                    renderCustom: function (swiper, current, total) {
                        var paginationHtml = "";
                        for (var i = 0; i < total; i++) {
                            if (i === (current - 1)) {
                                paginationHtml +=
                                    // '<div class="swiper-pagination-item">\
                                    '<img class="swiper-pagination-item" src="' + bannerS + '" />'
                                // </div>';
                            } else {
                                paginationHtml +=
                                    // '<div class="swiper-pagination-item">\
                                    '<img class="swiper-pagination-item" src="' + bannerN + '" />'
                                // </div>';
                            }
                        }
                        return paginationHtml;
                    }
                }
            },
            showTip: 1,
            toast: {
                show: false,
                msg: ''
            },
            tipCountdown: 30,
            tipMs: 0,
            initObj: {
                googleStoreUrl: '',
                appleStoreUrl: ''
            }
        }
    },
    mounted() {
        this.initData()
        trackPv(this.getChannel(this))
        this.startTipCountdown()
    },

    methods: {
        ...mapMutations(['loginLocal', 'initStore']),
        startTipCountdown() {
            trackClick('tip_show', this.getChannel(this))
            this.showTip = true
            this.tipCountdown = 30
            this.tipMs = 99
            const tick = () => {
                if (!this.showTip) return
                if (this.tipMs > 0) {
                    this.tipMs--
                } else if (this.tipCountdown > 0) {
                    this.tipCountdown--
                    this.tipMs = 99
                } else {
                    this.startTipCountdown()
                    return
                }
                setTimeout(tick, 10)
            }
            setTimeout(tick, 10)
        },
        openWeb(url) {
            setTimeout(() => {
                window.open(url, '_blank')
            }, 10)
        },
        initData() {
            this.isAndroid = !!!/iPhone|iPad/i.test(navigator.userAgent);
            api.init(this.getQueryString('v')).then(d => {
                d.googleStoreUrl = 'https://play.google.com/store/apps/details?id=com.vnlz.gp'
                d.appleStoreUrl = {
                    0: 'https://apps.apple.com/vn/app/dragon-raja-thức-tỉnh/id6756608951',
                    1: 'https://apps.apple.com/vn/app/dragon-raja-thức-tỉnh/id6756608951',
                    2: 'https://apps.apple.com/vn/app/dragon-raja-thức-tỉnh/id6756608951',
                    3: 'https://apps.apple.com/vn/app/dragon-raja-thức-tỉnh/id6756608951'
                }[this.p] || 'https://apps.apple.com/vn/app/dragon-raja-thức-tỉnh/id6756608951'
                this.initObj = d
                this.loginLocal({
                    people: d.people || 0
                })
                this.people = d.people || 0
                this.time = Math.max(d.time, 0) || 0
            }).catch(e => {
                console.error('initData ->', e)
                this.reqError(e)
            })


        },
        reqError(e) {
            alert(e.msg || 'unknown error')
        },
        toStore() {
            this.toast.show = false
            this.showTip = false
            const channel = this.getChannel(this)
            if (!this.isAndroid) {
                trackClick('click_store_apple', channel)
                this.$xmlog.clickStore(() => {
                    this.openWeb(this.initObj.appleStoreUrl)
                })
            } else {
                trackClick('click_store_google', channel)
                this.$xmlog.clickStore(() => {
                    this.openWeb(this.initObj.googleStoreUrl)
                })
            }
        },
        toStoreHero() {
            trackClick('click_store_hero', this.getChannel(this))
            this.toStore()
        },
        toStoreFloat() {
            trackClick('click_store_float', this.getChannel(this))
            this.toStore()
        },
        toStorePopup() {
            trackClick('click_store_popup', this.getChannel(this))
            this.toStore()
        },
        closeTip() {
            trackClick('tip_close', this.getChannel(this))
            this.showTip = false
        },
        toCafe() {
            trackClick('click_cafe', this.getChannel(this))
            this.openWeb('https://cafe.naver.com/runningthreekingdoms')
        },
        toGame() {
            trackClick('click_game', this.getChannel(this))
            this.openWeb('https://game.naver.com/lounge/RunningThreeKingdoms/home')
        },
        getChannel(self) {
            const query = new URLSearchParams(window.location.search).get('channel')
            return query || self.$route.params.channel || 'default'
        },
        getQueryString(name) {
            if (name === 'c') return this.getChannel(this);
            return '';
        },
        toLinke1() {
            trackClick('click_terms', this.getChannel(this))
            this.openWeb('https://www.facebook.com/vngamedragonraja')
        },
    }
}
